var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDiscountIcon = function SvgDiscountIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2998 4V3.25M7.2998 7.375V6.625M7.2998 10.75V10M3.6998 1H13.8998C14.7399 1 15.1599 1 15.4808 1.16349C15.763 1.3073 15.9925 1.53677 16.1363 1.81901C16.2998 2.13988 16.2998 2.55992 16.2998 3.4V4.375C14.8501 4.375 13.6748 5.55025 13.6748 7C13.6748 8.44975 14.8501 9.625 16.2998 9.625V10.6C16.2998 11.4401 16.2998 11.8601 16.1363 12.181C15.9925 12.4632 15.763 12.6927 15.4808 12.8365C15.1599 13 14.7399 13 13.8998 13H3.69981C2.85973 13 2.43969 13 2.11882 12.8365C1.83658 12.6927 1.6071 12.4632 1.46329 12.181C1.2998 11.8601 1.2998 11.4401 1.2998 10.6V9.625C2.74955 9.625 3.9248 8.44975 3.9248 7C3.9248 5.55025 2.74955 4.375 1.2998 4.375V3.4C1.2998 2.55992 1.2998 2.13988 1.46329 1.81901C1.6071 1.53677 1.83658 1.3073 2.11882 1.16349C2.43969 1 2.85973 1 3.6998 1Z",
    stroke: "#009369",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDiscountIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/discount-icon.b1774c2d.svg";
export { ForwardRef as ReactComponent };